export function getRandomInRange(center: number, range: number): number {
  // Generate random number between -range and +range
  const offset = (Math.random() - 0.5) * 2 * range // eslint-disable-line no-magic-numbers
  return center + offset
}
